import { Box, Grid } from "@mui/material";
import { ClaimBasedComponent } from "components/ClaimBasedComponent";
import NavCard from "components/NavCard";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { ClaimResource } from "types/claimTypes";

const ConfigurationPage = () => {
  const { formatMessage: t } = useIntl();
  const {
    organizationsUrl,
    dynamicMenuUrl,
    contentTemplatesUrl,
    rolesUrl,
    skuFormatsManagementUrl,
    regexValidationsUrl,
    wizardsUrl,
    settingsUrl,
    reprocessCompletionsUrl,
    contentBlocksUrl,
  } = useGlobalContext();

  return (
    <Box my={4}>
      <Grid container spacing={4}>
        <ClaimBasedComponent requestedClaims={[ClaimResource.Organizations]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "organizations" })} url={organizationsUrl()} />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.DynamicMenu]}>
          <Grid item xs={12} sm={4}>
            <NavCard
              title={t({ id: "menubarDynamicMenu" })}
              url={dynamicMenuUrl()}
            />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.ContentTemplates]}>
          <Grid item xs={12} sm={4}>
            <NavCard
              title={t({ id: "templatesLabel" })}
              url={contentTemplatesUrl()}
            />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Roles]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "rolesLabel" })} url={rolesUrl()} />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.SkuFormats]}>
          <Grid item xs={12} sm={4}>
            <NavCard
              title={t({ id: "skuFormatsTitle" })}
              url={skuFormatsManagementUrl()}
            />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.RegexValidations]}>
          <Grid item xs={12} sm={4}>
            <NavCard
              title={t({ id: "regexValidationsTitle" })}
              url={regexValidationsUrl()}
            />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Wizards]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "wizards" })} url={wizardsUrl()} />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Settings]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "settings" })} url={settingsUrl()} />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Settings]}>
          <Grid item xs={12} sm={4}>
            <NavCard
              title={t({ id: "reprocessCompletions" })}
              url={reprocessCompletionsUrl()}
            />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.ContentBlocks]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "contentBlocks" })} url={contentBlocksUrl()} />
          </Grid>
        </ClaimBasedComponent>
      </Grid>
    </Box>
  );
};

export default ConfigurationPage;
